import {useCallback, useEffect, useState} from 'react';
import {DoughnutChart, UntungRugiCard} from '../../../components';
import {Language} from '../../../context/LanguageContext';
import axios from 'axios';
import {APIURL} from '../../../consts';
import Cookies from 'js-cookie';
import '../../../assets/styles/untungRugi.scss';
import {numberWithCommas} from '../../../Helpers/stringFormat';
export default function UntungRugi({
  zoomer,
  projectCode,
  pkCode,
  negeriCode,
  wilayahCode,
  mapRef,
  setProjectCode,
  setPkCode,
  setNegeriCode,
  setMarkerClick,
  geoJsonLayer,
}) {
  const [payload, setPayload] = useState({
    type: 'pnp',
    jenisTanaman: 'Sawit',
  });
  const [data, setData] = useState(null);
  const {newObj, language} = Language();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    responsiveAnimationDuration: 0,
    aspectRatio: 1,
    width: '100%',
    plugins: {
      legend: {
        display: false, // set this to false to hide the legend
      },
    },
  };
  const handleZoomLevel = useCallback(
    (zoom) => {
      if (zoom >= 14) {
        let projectCodeSlice = null;
        if (projectCode) {
          if (projectCode[0] === 'F') {
            projectCodeSlice = projectCode.slice(1);
          } else if (projectCode[0] === 'J') {
            projectCodeSlice = projectCode.slice(2);
          } else {
            projectCodeSlice = projectCode;
          }
        }
        return {level: 'projek', kod: projectCodeSlice ? projectCodeSlice : ''};
      } else if (zoom >= 12) {
        return {level: 'kawasan', kod: pkCode ? pkCode : ''};
      } else if (zoom >= 10) {
        return {level: 'negeri', kod: negeriCode ? negeriCode : ''};
      } else if (zoom >= 8) {
        return {
          level: 'wilayah',
          kod: wilayahCode ? wilayahCode : '',
        };
      } else {
        return {level: 'all', kod: 'all'};
      }
    },
    [projectCode, pkCode, negeriCode, wilayahCode]
  );
  const handleTitleCard = useCallback(
    (zoom) => {
      if (zoom >= 14) {
        return 'namaProjek';
      } else if (zoom >= 12) {
        return 'namaProjek';
      } else if (zoom >= 10) {
        return 'namaKawasan';
      } else if (zoom >= 8) {
        return 'namaNegeri';
      } else {
        return 'namaWilayah';
      }
    },
    [zoomer]
  );
  const getData = useCallback(async () => {
    const zoomLevel = handleZoomLevel(zoomer);
    const formData = new FormData();
    formData.append('type', payload.type);
    formData.append('jenisTanaman', payload.jenisTanaman);
    formData.append('level', zoomLevel.level);
    formData.append('kod', zoomLevel.kod);
    formData.append('latitude_x', mapRef.current.getBounds()._southWest.lat);
    formData.append('longitude_x', mapRef.current.getBounds()._southWest.lng);
    formData.append('latitude_y', mapRef.current.getBounds()._northEast.lat);
    formData.append('longitude_y', mapRef.current.getBounds()._northEast.lng);
    formData.append('center_lat', mapRef.current.getBounds().getCenter().lat);
    formData.append('center_long', mapRef.current.getBounds().getCenter().lng);
    formData.append('flag', zoomLevel.kod ? 'click' : 'drag');
    formData.append('status', 'publish');
    if (
      zoomLevel.level !== 'projek' ||
      (zoomLevel.level === 'projek' && zoomLevel.kod)
    ) {
      const response = await axios.post(
        APIURL.map_kewangan_get_data,
        formData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get('token')}`,
          },
        }
      );
      const {data} = response;
      setData(data);
    }
  }, [payload, zoomer, projectCode, pkCode, negeriCode, wilayahCode]);
  const handleOnClick = (zoom, item) => {
    // const find = geoJsonLayer?.features?.find((geoItem) => {
    //   if (zoom < 8) return geoItem.properties.code === item.kodWilayah;
    //   else if (zoom >= 8 && zoom < 10)
    //     return geoItem.properties.code === item.kodNegeri;
    //   else if (zoom >= 10 && zoom < 12)
    //     return geoItem.properties.code === item.kodKawasan;
    //   else if (zoom >= 12)
    //     return geoItem.properties.code.slice(1) === item.kodProjek;
    // });
    if (item.latitude > 0 && item.longitude > 0) {
      if (zoom >= 8 && zoom < 10) {
        setNegeriCode(item.code);
      } else if (zoom >= 10 && zoom < 12) {
        setPkCode(item.code);
      } else if (zoom >= 12) {
        setProjectCode(item.code);
        setMarkerClick(true);
      }

      mapRef.current.flyTo(
        [item.latitude, item.longitude],
        mapRef.current.getZoom() + 2
      );
    }
  };
  const handleTypeWording = (type) => {
    switch (type) {
      case 'pnp':
      default:
        return {
          title: 'P&P',
          data: [
            {
              label: 'PENDAPATAN',
              value: data?.detail?.pendapatan,
              prefix: 'RM ',
            },
            {
              label: 'KOS OPERASI',
              value: data?.detail?.kosOperasi,
              prefix: 'RM ',
            },
            {
              label: 'POTONGAN WAJIB',
              value: data?.detail?.potonganWajib,
              prefix: 'RM ',
            },
            {
              label: 'LAIN-LAIN PENDAPATAN',
              value: data?.detail?.lainLainPendapatan,
              prefix: 'RM ',
            },
            // {
            //   label: 'AGIHAN',
            //   value: data?.detail?.lainLainPendapatan,
            // },
          ],
          highlight: [
            {
              label: 'UNTUNG(RUGI) SEMASA',
              value: data?.detail?.untungRugiSemasa,
              prefix: 'RM ',
            },
          ],
        };
      case 'fb':
        return {
          title: 'ESTET FB',
          data: [
            {
              label: 'PENDAPATAN',
              value: data?.detail?.pendapatan,
              prefix: 'RM ',
            },
            {
              label: 'LAIN-LAIN PENDAPATAN',
              value: data?.detail?.lainLainPendapatan,
              prefix: 'RM ',
            },
            {
              label: 'KOS OPERASI',
              value: data?.detail?.kosOperasi,
              prefix: 'RM ',
            },
          ],
          highlight: [
            {
              label: 'UNTUNG(RUGI) OPERASI',
              value: data?.detail?.untungRugiOperasi,
              prefix: 'RM ',
            },
          ],
        };
      case 'jv':
        return {
          title: 'ESTET JV',
          data: [
            {
              label: 'PENDAPATAN',
              value: data?.detail?.pendapatan,
              prefix: 'RM ',
            },
            {
              label: 'KOS OPERASI',
              value: data?.detail?.kosOperasi,
              prefix: 'RM ',
            },
            {
              label: 'LAIN-LAIN PENDAPATAN',
              value: data?.detail?.lainLainPendapatan,
              prefix: 'RM ',
            },
            {
              label: 'MARGIN UNTUNG KASAR %',
              value: data?.detail?.marginUntungKasar,
              prefix: '',
              suffix: ' %',
            },
            {
              label: 'BELANJA PENTADBIRAN',
              value: data?.detail?.belanjaPentadbiran,
              prefix: 'RM ',
            },
            {
              label: 'SUSUT NILAI',
              value: data?.detail?.susutNilai,
              prefix: 'RM ',
            },
            {
              label: 'KOS KEWANGAN',
              value: data?.detail?.kosKewangan,
              prefix: 'RM ',
            },
          ],
          highlight: [
            {
              label: 'UNTUNG(RUGI) OPERASI',
              value: data?.detail?.untungRugiOperasi,
              prefix: 'RM ',
            },
            {
              label: 'UNTUNG(RUGI) SEBELUM CUKAI',
              value: data?.detail?.untungRugiSebelumCukai,
              prefix: 'RM ',
            },
            {
              label: 'UNTUNG(RUGI) SELEPAS CUKAI',
              value: data?.detail?.untungRugiSelepasCukai,
              prefix: 'RM ',
            },
          ],
        };
    }
  };
  const handleValueType = (type) => {
    switch (type) {
      case 'fb':
        return 'untungRugiOperasi';
      case 'jv':
        return 'untungRugiSelepasCukai';
      case 'pnp':
      default:
        return 'untungRugiSemasa';
    }
  };
  useEffect(() => {
    getData();
  }, [zoomer, payload]);

  return (
    <div className={`ug_ctr ${zoomer >= 16 ? '' : ''}`}>
      <div className='ug_data_ctr'>
        <div className='ug_filter'>
          <div className='ug_toggle'>
            <div
              className={`ug_toggle_item ${
                payload.type === 'pnp' ? 'active' : ''
              }`}
              onClick={() => setPayload((prev) => ({...prev, type: 'pnp'}))}
            >
              P&P
            </div>
            <div
              className={`ug_toggle_item  ${
                payload.type === 'fb' ? 'active' : ''
              }`}
              onClick={() => setPayload((prev) => ({...prev, type: 'fb'}))}
            >
              ESTET FB
            </div>
            <div
              className={`ug_toggle_item  ${
                payload.type === 'jv' ? 'active' : ''
              }`}
              onClick={() => setPayload((prev) => ({...prev, type: 'jv'}))}
            >
              ESTET JV
            </div>
          </div>
        </div>
        <p className='ug_title'>
          RUMUSAN UNTUNG DAN RUGI
          <br />
          PROJEK {handleTypeWording(payload.type).title} BAGI BULAN{' '}
          {data?.detail.periode}
        </p>
        <div
          className={`ug_doughnut ${
            data?.projekUntungRugi?.untung > 0 ? 'untung' : 'rugi'
          }`}
        >
          <div className='ug_filter'>
            <div className='ug_tabs'>
              <div
                className={`ug_tab_item ${
                  payload.jenisTanaman === 'Sawit' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, jenisTanaman: 'Sawit'}))
                }
              >
                {newObj.SawitWord[language]}
              </div>
              <div
                className={`ug_tab_item  ${
                  payload.jenisTanaman === 'Getah' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, jenisTanaman: 'Getah'}))
                }
              >
                {newObj.GetahWord[language]}
              </div>
              <div
                className={`ug_tab_item  ${
                  payload.jenisTanaman === 'Padi' ? 'active' : ''
                }`}
                onClick={() =>
                  setPayload((prev) => ({...prev, jenisTanaman: 'Padi'}))
                }
              >
                {newObj.PadiWord[language]}
              </div>
            </div>
          </div>
          <div className='doughnut_ctr'>
            <div className='doughnut_wrapper'>
              <DoughnutChart
                data={{
                  labels: ['Rugi', 'Untung'],
                  datasets: [
                    {
                      label: 'Projek',
                      data: [
                        data?.projekUntungRugi?.rugi,
                        data?.projekUntungRugi?.untung,
                      ],
                      backgroundColor: ['#E51D28', '#2B5180'],
                      hoverBackgroundColor: ['#E51D28', '#2B5180'],
                      borderColor: ['#E51D28', '#2B5180'],
                      borderWidth: 1,
                    },
                  ],
                }}
                options={options}
              />
            </div>
            <div className='doughnut_bar'>
              <div className='bar_item'>
                <div className='border blue'></div>
                <div>
                  <p>Projek Untung</p>
                  <p className='untung'>{data?.projekUntungRugi?.untung}</p>
                </div>
              </div>
              <div className='bar_item'>
                <div className='border red'></div>
                <div>
                  <p>Projek Rugi</p>
                  <p className='rugi'>{data?.projekUntungRugi?.rugi}</p>
                </div>
              </div>
            </div>
          </div>
          <div className='highlight'>
            {handleTypeWording(payload.type).highlight.map((item, index) => (
              <div className='highlight_item'>
                <p>{item.label}</p>
                <p className={`text  ${item.value < 0 ? 'rugi' : ''}`}>
                  {item.prefix} {numberWithCommas(item.value)}
                </p>
              </div>
            ))}
          </div>
          <div className='data_list'>
            {handleTypeWording(payload.type).data.map((item, index) => (
              <div className='data_item'>
                <p>{item.label}</p>
                <p className={`text`}>
                  {item.prefix} {numberWithCommas(item.value)}{' '}
                  {item.suffix && item.suffix}
                </p>
              </div>
            ))}
            <div className='date'>
              <p>Tarikh kemas kini: {data?.detail?.tarikh_kemas_kini}</p>
            </div>
          </div>
        </div>
        <p className='ug_title'>RUMUSAN UNTUNG DAN RUGI</p>
        <div className='ug_card_list'>
          {data?.rumusan?.map((item, index) => (
            <UntungRugiCard
              untungRugiSemasa={item[handleValueType(payload.type)]}
              title={item[handleTitleCard(zoomer)]}
              untung={item.untung}
              rugi={item.rugi}
              onClick={() => handleOnClick(zoomer, item)}
              key={`ug_card_${index}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
